// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'

// Redux:
import { closeMenu } from 'church-theme-library/redux/actions/site'
import { getPageData } from 'church-theme-library/redux/actions/page'

class Menu extends React.Component {
	// constructor( props ) {
	// 	super( props )
	// }

	handleMenuItemClick = () => {
		const { dispatch } = this.props

		dispatch( closeMenu() )
	}

	handleMenuItemMouseOver = ( e ) => {
		// Fails to change page when quickly right after -
		// Sets this to loading, preventing other requests from going through,
		// thus preventing the page from being set after click.

		// const { dispatch } = this.props
		// let slug = e.currentTarget.getAttribute( 'data-id' )

		// if ( slug ) {
		// 	dispatch(
		// 		getPageData( {
		// 			slug: slug,
		// 			requestOnly: true
		// 		} )
		// 	)
		// }
	}

	handleMoreButtonClick = () => {

	}

	handleMobileMenuParentItemClick = ( e ) => {
		e.currentTarget.parentNode.classList.toggle( 'is-active-dropdown' )
	}

	renderLink( item, showChildren = false ) {
		if ( ! item || ! item.url ) {
			return null
		}

		const { mobile } = this.props
		let linkMarkup,
			iconClass = item.icon_class ? item.icon_class : 'list',
			dropdownIndicator = null

		if ( showChildren ) {
			dropdownIndicator = <i className="-dropdown-indicator icon-chevron-down" />
		}

		if ( '/' === item.url ) {
			linkMarkup = (
				<NavLink to='/' exact activeClassName="is-active" onClick={ this.handleMenuItemClick }>
					<span>{ item.title }{ dropdownIndicator }</span>
				</NavLink>
			)
		} else if ( item.url.indexOf( '//' ) > -1 ) {
			linkMarkup = (
				<a href={ item.url } target="_blank" onClick={ this.handleMenuItemClick }>
					<span>{ item.title }{ dropdownIndicator }</span>
				</a>
			)
		} else {
			linkMarkup = (
				<NavLink
					to={ item.url }
					exact
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemMouseOver }
					data-id={ item.url }
				>
					<span>{ item.title }{ dropdownIndicator }</span>
				</NavLink>
			)
		}

		return linkMarkup
	}

	render() {
		let { mobile, menuIsOpen, menuItems, menuOverflowItems, userCanEditPage, locale, translate } = this.props
		let wrapClass = mobile ? 'mobile-menu-wrap' : 'primary-menu-wrap'

		if ( menuIsOpen ) {
			wrapClass += ' on-mobile-is-active'
		}

		let menuItemsMarkup,
			menuOverflowItemsMarkup,
			liClass = mobile ? '' : 'js-priority-plus-menu-item',
			editableMenuItems = [],
			hasHome = false

		if ( menuItems && Object.keys( menuItems ).length ) {
			menuItemsMarkup = Object.keys( menuItems )
				.map( ( key ) => {
					// Top level:

					let item = menuItems[ key ],
						childrenItemsMarkup,
						showChildren = false

					if ( `${siteData.site_base_path}/` == item.url  ) {
						hasHome = true
					}

					if ( item.children && Object.keys( item.children ).length ) {
						// Children:

						showChildren = true
						liClass += ` with-dropdown`
						childrenItemsMarkup = Object.keys( item.children )
							.map( ( key ) => {
								let childLinkMarkup = this.renderLink( item.children[ key ] )

								return (
									<li key={ key }>
										{ childLinkMarkup }
									</li>
								)
							} )
					}

					let linkMarkup = this.renderLink( item, showChildren )

					if ( mobile && showChildren ) {
						return (
							<li className={ liClass } data-id={ key } key={ key }>
								<div className="-parent-link js-mobile-menu-parent-link" onClick={ this.handleMobileMenuParentItemClick }>
									{ item.title }
									<i className="icon-plus-round" />
								</div>

								<div className="-dropdown">
									<ul>
										<li>{ linkMarkup }</li>
										{ childrenItemsMarkup }
									</ul>
								</div>
							</li>
						)
					} else {
						return (
							<li className={ liClass } data-id={ key } key={ key }>
								{ linkMarkup }

								{ showChildren &&
									<div className="-dropdown">
										<ul>
											{ childrenItemsMarkup }
										</ul>
									</div>
								}
							</li>
						)
					}
				} )

			if ( userCanEditPage ) {
				Object.keys( menuItems ).map( ( key ) => {
					// Top level:

					let item = menuItems[ key ]

					editableMenuItems.push( {
						id: item.id,
						object_id: item.object_id,
						name: item.title,
						path: []
					} )

					if ( item.children && Object.keys( item.children ).length ) {
						// Children:

						Object.keys( item.children ).map( ( key ) => {
							let itemChild = item.children[ key ]

							editableMenuItems.push( {
								id: itemChild.id,
								object_id: itemChild.object_id,
								name: itemChild.title,
								path: [ item.id ]
							} )
						} )
					}
				} )

				editableMenuItems = JSON.stringify( editableMenuItems )
			}
		}

		if ( menuOverflowItems && menuOverflowItems.length ) {
			menuOverflowItemsMarkup = menuOverflowItems
				.map( key => {
					if ( ! menuItems[ key ] ) {
						return null
					}

					// Top level:

					let item = menuItems[ key ],
						childrenMarkup = '',
						linkMarkup = this.renderLink( item )

					if ( item.children && Object.keys( item.children ).length ) {
						// Children:

						let childrenItemsMarkup = Object.keys( item.children )
							.map( ( key ) => {
								let childLinkMarkup = this.renderLink( item.children[ key ] )

								return (
									<li key={ key }>
										{ childLinkMarkup }
									</li>
								)
							} )

						childrenMarkup = (
							<div className="-dropdown">
								<ul>
									{ childrenItemsMarkup }
								</ul>
							</div>
						)
					}

					return (
						<li key={ key }>
							{ linkMarkup }
							{ childrenMarkup }
						</li>
					)
				} )
		}

		if ( menuItemsMarkup && mobile && ! hasHome ) {
			menuItemsMarkup.unshift(
				<li key="mobile_home">
					{ this.renderLink( {
						id: '',
						title: translate( 'Home' ),
						url: `${siteData.site_base_path}/`,
						icon_class: ''
					} ) }
				</li>
			)
		}

		return (
			<div className={ wrapClass }>
				<Editable id="site_menu" className="primary-menu" menuItems={ editableMenuItems } menuId={ `site_menu_${locale}` }>
					<ul className="-menu">
						{ menuItemsMarkup }
					</ul>
				</Editable>

				{ menuOverflowItemsMarkup &&
					<div className="-menu-overflow-more" type="button" onClick={ this.handleMoreButtonClick }>
						<div className="-dots">
							<div></div>
							<div></div>
							<div></div>
						</div>

						<div className="-menu">
							<div className="-overflow-dropdown">
								<ul>{ menuOverflowItemsMarkup }</ul>
							</div>
						</div>
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let selected = state.page.selectedArchive ? state.page.selectedArchive : state.page.selected,
		// userCanEditPage = selected && selected.user_can_edit ? selected.user_can_edit : false
		userCanEditPage = siteData.current_user_can_edit_pages,
		pageId = selected && selected.id ? selected.id : false

	if ( selected && selected.is_external ) {
		userCanEditPage = false
	}

	return {
		menuIsOpen: state.site.menuIsOpen,
		menuItems: state.site.menuItems,
		menuOverflowItems: state.site.menuOverflowItems,
		locale: state.site.locale,
		page: state.page.selected,
		userCanEditPage: userCanEditPage
	}
}

export default localize(
	connect( mapStateToProps )( Menu )
)
